<mat-form-field appearance="outline" class="custom-field">
  <mat-label>Mes y año</mat-label>
  <input matInput [matDatepicker]="dp" [formControl]="date" placeholder="Month and Year" [min]="min" [max]="max">
  <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
  <mat-datepicker #dp startView="multi-year" (monthSelected)="setMonthAndYear($event, dp)"
    panelClass="example-month-picker">
  </mat-datepicker>
</mat-form-field>
